import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { CommonDialog } from 'src/components/shared/dialog/CommonDialog';
import { getQueryParam } from 'src/lib/utils';

export const FollowFailedDialog = () => {
  const { t } = useTranslation(['resort', 'translation']);
  const title = t('translation:dialog_error');
  const location = useLocation();
  const error = getQueryParam(location.search, 'error');
  // クエリが存在しない場合は、空の文言を出力
  const description = error ? getErrorDescription(t, error) : '';
  return <CommonDialog title={title} description={description} />;
};

// helper function
// クエリのエラー内容に従って、ダイアログ本文を出力する関数
function getErrorDescription(t: TFunction, error?: string): string {
  switch (error) {
    case 'unstable-network':
      return t('translation:error_unstable_network');
    case 'limit-of-follow':
      return t('error_reached_follow_limit');
    default:
      return t('translation:error_unknown');
  }
}
